import { render, staticRenderFns } from "./Attribute.vue?vue&type=template&id=4b933858"
import script from "./Attribute.vue?vue&type=script&lang=ts"
export * from "./Attribute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports